import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-request',
    templateUrl: './request.component.html',
    styleUrls: ['./request.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('request')
export class RequestComponent  {
    formGroup = input<FormGroup>();
    model = input<any>();

    metaMethod: any = {
        id: 'method',
        name: 'Method',
        value: 'value',
        label: 'name',
        options: [
            { name: 'GET', value: 'get' },
            { name: 'POST', value: 'post' }
        ]
    };

    metaUrl: any = { id: 'url', name: 'Url' };
}
